import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_TCF_VENDOR_CONTEXT_SYMBOL = Symbol();
const useFormTcfVendor = ()=>useImmutableContext(FORM_TCF_VENDOR_CONTEXT_SYMBOL);
const useFormTcfVendorProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(FORM_TCF_VENDOR_CONTEXT_SYMBOL, ...args);
};
export { useFormTcfVendor, useFormTcfVendorProvider };
